<template>
  <div>
    <div v-if="getMainStaff(item)">
      <span class="text-muted">Chính</span>:
      <b-link
        :href="`/staff/detail/?id=${getMainStaff(item).staffId}`"
        target="_blank"
      >
        {{ getMainStaff(item).staffName }}
        {{
          getMainStaff(item).staffRole
            ? '- ' + getRole(getMainStaff(item).staffRole)
            : ''
        }}
      </b-link>
    </div>
    <div v-if="getSecondStaff(item)">
      <span class="text-muted">Phụ</span>:
      <!-- <span v-html="truncatedText(item)"></span> -->
      <span
        v-for="(staff, index) in getSecondStaffArr(item)"
        :key="staff.staffId"
      >
        <a
          v-if="index < 3"
          style="cursor: pointer"
          :href="`/staff/detail/?id=${staff.staffId}`"
          target="_blank"
        >
          {{
            `${staff.staffName + (getRole(staff.staffRole) ? (' - ' + getRole(staff.staffRole)) : '')}${index < getSecondStaffArr(item).length - 1 ? '; ' : ''}`
          }}
        </a>
      </span>
      <span
        v-if="remainingCount(getSecondStaff(item))"
        v-b-tooltip.hover="{ customClass: 'tooltip-class' }"
        v-b-tooltip.hover.html="tooltipContent(item)"
        style="cursor: pointer"
      >
        ...{{ remainingCount(getSecondStaff(item)) }}
      </span>
    </div>
  </div>
</template>

<script>
import { MaRole } from '@/constant/customerSupport'

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    getMainStaff() {
      return (maInfo) => {
        return maInfo && maInfo.length > 0
          ? maInfo.find((uInfo) => uInfo[this.type] === 'MAIN')
          : undefined
      }
    },
    getSecondStaff() {
      return (maInfo) => {
        const usersInfo =
          maInfo && maInfo.length > 0
            ? maInfo.filter((uInfo) => uInfo[this.type] === 'SECOND')
            : []
        if (usersInfo) {
          return usersInfo
            .reduce((arr, userInfo) => {
              arr.push(userInfo.staffName)
              return arr
            }, [])
            .join(', ')
        }
        return ''
      }
    },
    getSecondStaffArr() {
      return (maInfo) => {
        const usersInfo =
          maInfo && maInfo.length > 0
            ? maInfo.filter((uInfo) => uInfo[this.type] === 'SECOND')
            : []
        return usersInfo
      }
    },
    remainingCount() {
      return (maInfo) => {
        const parts = maInfo.split(', ')
        if (parts.length > 3) {
          return `+${parts.length - 3}`
        }
        return ''
      }
    },
    tooltipContent() {
      return (maInfo) => {
        const usersInfo =
          maInfo && maInfo.length > 0
            ? maInfo.filter((uInfo) => uInfo[this.type] === 'SECOND')
            : []
        if (usersInfo) {
          const parts = usersInfo.reduce((arr, userInfo) => {
            arr.push({
              id: userInfo.staffId,
              name: userInfo.staffName,
              role: userInfo.staffRole
            })
            return arr
          }, [])
          if (parts.length > 3) {
            return parts
              .slice(3)
              .map((item) => {
                return `<a style="cursor: pointer;" href='/staff/detail/?id=${item.id}' target="_blank">${item.name + (this.getRole(item.role) ? (' - ' + this.getRole(item.role)) : '')}</a>`
              })
              .join('<br>')
          }
        }
        return ''
      }
    }
  },
  data() {
    return {
      MaRole
    }
  },
  methods: {
    getRole(role) {
      const objRole = this.MaRole.find((s) => s.id === role)
      return objRole ? objRole.text : role
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip-class .tooltip-inner {
  background-color: rgb(253, 253, 253);
  color: #319db5;
  text-align: left;
  max-height: 150px;
  max-width: 200px;
  overflow-y: auto;
  border: 1px solid;
}
</style>
